import { render, staticRenderFns } from "./SectionAgencyLegalInformationStatus.vue?vue&type=template&id=285de04a&"
import script from "./SectionAgencyLegalInformationStatus.vue?vue&type=script&lang=js&"
export * from "./SectionAgencyLegalInformationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports